var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNrgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.2002C12.4183 16.2002 16 12.6185 16 8.2002C16 3.78192 12.4183 0.200195 8 0.200195C3.58172 0.200195 0 3.78192 0 8.2002C0 12.6185 3.58172 16.2002 8 16.2002Z",
    fill: "#00E676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00086 1.00391C5.09036 1.00391 2.46646 2.75715 1.35266 5.4461C0.23886 8.13505 0.854516 11.2302 2.91255 13.2882C4.97058 15.3462 8.06569 15.9619 10.7546 14.8481C13.4436 13.7343 15.1968 11.1104 15.1968 8.19987C15.1987 6.2908 14.4412 4.45938 13.0913 3.10946C11.7414 1.75954 9.90993 1.00201 8.00086 1.00391ZM8.00086 14.5918C4.4707 14.5918 1.60893 11.73 1.60893 8.19987C1.60893 4.66971 4.4707 1.80795 8.00086 1.80795C11.531 1.80795 14.3928 4.66971 14.3928 8.19987C14.3954 9.89591 13.7228 11.5232 12.5235 12.7225C11.3242 13.9218 9.69689 14.5944 8.00086 14.5918Z",
    fill: "#0BBA64"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7841_1702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 10,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9946 8.20507L8.08533 13.0324L3.17578 8.20507L8.08677 3.37598L11.1537 6.39484L8.08533 9.4117L6.85809 8.20507L8.69924 6.39484L8.08562 5.79124L5.63084 8.20507L8.08562 10.6189L11.7674 6.99815L12.9946 8.20507Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7841_1702)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7841_1702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17578 21.1438H20.9436V3.37598H3.17578V21.1438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7841_1702)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7841_1702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7152 2.48145H2.26172V13.935H13.7152V2.48145Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7841_1702)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7841_1702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37109 13.7213H13.859V2.57129H2.37109V13.7213Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7841_1702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53125 2.73047H13.6377V13.6746H2.53125V2.73047Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrgTable);
export default __webpack_public_path__ + "static/media/NRGTable.f6daa973cbe2e54d06367b87e8fdc673.svg";
export { ForwardRef as ReactComponent };